class GuidelineTab {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $(".js-tab-content").hide();
    $(".js-tab:first").addClass("is-active");
    $(".js-tab-content:first").show();

    $(".js-tab").click(function(){
      $(".js-tab-content").hide();
      var index = $(this).index();
      $(".js-tab-content").eq(index).show();

      $(".js-tab").removeClass("is-active");
      $(this).addClass("is-active");
    }); 
  }
}